import { render, staticRenderFns } from "./StudentEvidence.vue?vue&type=template&id=7cd1cdc8&scoped=true&"
import script from "./StudentEvidence.vue?vue&type=script&lang=js&"
export * from "./StudentEvidence.vue?vue&type=script&lang=js&"
import style0 from "./StudentEvidence.vue?vue&type=style&index=0&id=7cd1cdc8&prod&lang=scss&scoped=true&"
import style1 from "./StudentEvidence.vue?vue&type=style&index=1&id=7cd1cdc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd1cdc8",
  null
  
)

export default component.exports